import { render } from "./App.vue?vue&type=template&id=4b9694e4"
const script = {}

import exportComponent from "/home/runner/work/webeye-pro-frontend/webeye-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__